var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFirstViewDots = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 100,
  height: 100,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 3.33,
  cy: 3.33,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 56.605,
  cy: 3.33,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 56.605,
  cy: 56.604,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 3.33,
  cy: 56.604,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 3.33,
  cy: 29.967,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
  cx: 56.605,
  cy: 29.967,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
  cx: 56.605,
  cy: 83.242,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
  cx: 3.33,
  cy: 83.242,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
  cx: 29.966,
  cy: 29.967,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
  cx: 83.242,
  cy: 29.967,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
  cx: 83.242,
  cy: 83.242,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
  cx: 29.968,
  cy: 83.242,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
  cx: 29.966,
  cy: 3.33,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
  cx: 83.242,
  cy: 3.33,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
  cx: 83.242,
  cy: 56.604,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
  cx: 29.968,
  cy: 56.604,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
  cx: 16.648,
  cy: 3.33,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
  cx: 69.923,
  cy: 3.33,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
  cx: 69.923,
  cy: 56.604,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
  cx: 16.648,
  cy: 56.604,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
  cx: 16.648,
  cy: 29.967,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
  cx: 69.923,
  cy: 29.967,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
  cx: 69.923,
  cy: 83.242,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
  cx: 16.648,
  cy: 83.242,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
  cx: 43.285,
  cy: 29.967,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
  cx: 96.56,
  cy: 29.967,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
  cx: 96.56,
  cy: 83.242,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
  cx: 43.287,
  cy: 83.242,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
  cx: 43.285,
  cy: 3.33,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
  cx: 96.56,
  cy: 3.33,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
  cx: 96.56,
  cy: 56.604,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
  cx: 43.287,
  cy: 56.604,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
  cx: 16.648,
  cy: 16.648,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
  cx: 69.923,
  cy: 16.648,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
  cx: 69.923,
  cy: 69.923,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
  cx: 16.648,
  cy: 69.923,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
  cx: 16.648,
  cy: 43.286,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
  cx: 69.923,
  cy: 43.286,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
  cx: 69.923,
  cy: 96.56,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
  cx: 16.648,
  cy: 96.56,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
  cx: 43.285,
  cy: 43.286,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
  cx: 96.56,
  cy: 43.286,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
  cx: 96.56,
  cy: 96.56,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
  cx: 43.287,
  cy: 96.56,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
  cx: 43.285,
  cy: 16.648,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
  cx: 96.56,
  cy: 16.648,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
  cx: 96.56,
  cy: 69.923,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
  cx: 43.287,
  cy: 69.923,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
  cx: 3.33,
  cy: 16.648,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
  cx: 56.605,
  cy: 16.648,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
  cx: 56.605,
  cy: 69.923,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
  cx: 3.33,
  cy: 69.923,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
  cx: 3.33,
  cy: 43.286,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
  cx: 56.605,
  cy: 43.286,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
  cx: 56.605,
  cy: 96.56,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
  cx: 3.33,
  cy: 96.56,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
  cx: 29.966,
  cy: 43.286,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
  cx: 83.242,
  cy: 43.286,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
  cx: 83.242,
  cy: 96.56,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
  cx: 29.968,
  cy: 96.56,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
  cx: 29.966,
  cy: 16.648,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
  cx: 83.242,
  cy: 16.648,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
  cx: 83.242,
  cy: 69.923,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
  cx: 29.968,
  cy: 69.923,
  r: 3.33,
  fill: "#fff",
  fillOpacity: 0.75
})));
export default SvgFirstViewDots;